import {
  getFromStorage,
  getStorageJSON,
  UNITE_CALL_SERVER_VERSION,
  UNITE_DEVELOPMENT,
} from 'constants/LocalStorage'
import { SERVER_VERSION, SERVER_VERSION_MAP } from 'constants/Servers'

const { V2 } = SERVER_VERSION

export const serverVersion = () => {
  const debug = getStorageJSON(UNITE_DEVELOPMENT, false)
  if (debug?.version) {
    return debug.version
  }

  const server = getFromStorage(UNITE_CALL_SERVER_VERSION)

  return SERVER_VERSION_MAP[server] || V2
}

const createAPIEnvCommon = (
  environment,
  { API_PUBLIC, API_UNITE, AUTH_URL },
) => {
  return {
    environment,
    servers: { API_PUBLIC, API_UNITE, AUTH_URL },
  }
}

export const createAPIEnvironment = ({
  environment,
  apiConfig,
  version = serverVersion(),
}) => {
  return {
    ...createAPIEnvCommon(environment, apiConfig),
    version,
  }
}

export const createUAEnvironment = (uaData) => {
  const {
    webRTCHost = '',
    webRTCPort = '',
    webRTCTransport = '',
    proxyHost = '',
    proxyPort = '',
    sipUri = '',
    stunServers = undefined,
  } = uaData

  const uaConfig = {
    UA_URI: sipUri || `${proxyHost}${proxyPort ? `:${proxyPort}` : ''}`,
    UA_SOCKET: `wss://${webRTCHost}:${webRTCPort}`,
    UA_TRANSPORT: webRTCTransport,
    ...(stunServers ? { UA_STUN_URLS: String(stunServers).split(',') } : {}),
  }

  return { ua: uaConfig }
}
